import { useQuery } from "@tanstack/react-query"
import { getOrderById } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetOrderById(id: string, enabled: boolean = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["buyer-order-detail", id],
    queryFn: () => getOrderById(id, accessToken!),
    enabled: !!accessToken && !!id && enabled,
    staleTime:0,
  })
}
